<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Data Inicial', 'Tipo', 'Condição', 'Descrição', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"  :status="obj.inactive ? 0 : 1" :value="obj.dataInicial ? formatData(obj.dataInicial) : ''" />
        <TableColumn :IsText="true"  :status="obj.inactive ? 0 : 1" :value="obj.tipo" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inactive ? 0 : 1" :value="formatCondicao(obj.condicao)" />
        <TableColumn :IsText="true"  :status="obj.inactive ? 0 : 1" :value="obj.descricao" />
        <td class="text-center">
          <div v-if="!obj.inactive">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-lock-open text-secundary icone-grid"
                  style="color: black"
                  :title="'Inativar finalização'"
                ></i>
              </template>
              <b-dropdown-header>
                <strong>{{
                  'Confirmar inativação da finalização'
                }}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="changeStatus(obj, 'true')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-else>
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-ban text-secundary icone-grid"
                  style="color: red"
                  :title="'Ativar finalização'"
                ></i>
              </template>
              <b-dropdown-header>
                <strong>{{
                  'Confirmar ativação da finalização'
                }}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="changeStatus(obj, 'false')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'">
          <i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import TipoFinalizacaoValueRepository from '@/shared/http/repositories/configurations/tipofinalizacao.js'
import TipoFinalizacaoValueSearchScreen from '../search/search.vue'

export default {
  name: 'TipoFinalizacaoValueList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        TipoFinalizacaoValueRepository.Search(this.filters.data, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        TipoFinalizacaoValueRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      TipoFinalizacaoValueRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: TipoFinalizacaoValueSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    },
    formatData (data) {
      return this.moment(new Date(data)).tz('UTC').format('DD/MM/YYYY')
    },
    formatCondicao (condicao) {
      if (condicao === null) {
        return 'Neutro'
      } else if (condicao) {
        return 'Positivo'
      } else {
        return 'Negativo'
      }
    },
    async changeStatus (obj, status) {
      try {
        loading.push()

        let data = {
          inactive: status
        }

        await TipoFinalizacaoValueRepository.ChangeStatus(obj.id, data)
        this.onLoadAll()
      } catch (e) {
        this.onException(e)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/TiposFinalizacao/components/list/TiposFinalizacaoList.vue